module.exports = __webpack_public_path__ + "static/media/newsImage4.4c1868cb.svg";